import HttpBEService from './http-backend-service'
import { BE_API } from '../data/constants'
import axiosBEInstance from '../utils/axios-backend'

class LogService extends HttpBEService{

    async submitLog(data:any){
        try {
            axiosBEInstance.request({
                url: BE_API.LOG,
                method: 'post',
                data
            })
        } catch (error) {}
    }
    
}


export default new LogService();